import React, { useEffect } from 'react';
import '../../campaign/campaignCreation/CreateCampaignStepTwo.scss';
import { useDispatch, connect } from 'react-redux';
import { CampaignType } from '../../../config/CustomEnums';
import {
  OnlyContinueButton,
} from '../../base/BottomStepComponent';
import {
  defaultPreviewImage,
  getPreviewLayoutImages,
} from '../../campaign/campaignCreation/CampaignStepTwoPreviewConfig';
import { useFormContext } from 'react-hook-form';
import { validate } from '../../../containers/engagement/campaign/CreateCampaignValidate';
import { scrollToFirstError } from 'components/campaign/campaignCreation/CreateCampaignHandleError';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { CREATION_STEP_ONE_CONFIG } from './StampCampaignCreationConfig';

function CreateStampCampaignStepOneV2({ languages }) {
  const { getValues, formState: { errors }, clearErrors, setError, setValue } =
    useFormContext();
  const fieldError = Object.keys(errors || []).length;

  const campaignTypeField = "campaignType"
  const defaultCampaignType = CampaignType.stampCampaign;
  const dispatch = useDispatch();
  const defaultImage = defaultPreviewImage(defaultCampaignType);
  const inputWithImageConfig = getPreviewLayoutImages(defaultCampaignType);
  const { extraValidate } = CREATION_STEP_ONE_CONFIG;

  useEffect(() => {
    console.log("@@scrollToFirstError", errors)
    scrollToFirstError(
      errors,
      [
        "translations.en.generalName",
        "translations.en.coverPhoto",
        "translations.en.squareCoverPhoto",
        "stampCampaignTypeEmptySlotStampImage",
        "stampCampaignTypeAcquiredStampImage",
        "stampCampaignTypeEmptyGiftSlotImage",
        "stampCampaignTypeCollectedGiftImage",
        "linkedEarningRules",
        "stampRewardHasError",
      ]
    )
  }, [errors]);

  useEffect(() => {
    if (getValues(campaignTypeField)) {
      return;
    }
    setValue(campaignTypeField, defaultCampaignType);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languages]);

  const stepChangeAction = () => {
    let isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 0,
      languages: languages?.map(item=>item.code),
    });
    if (extraValidate) {
      isValid = extraValidate({
        getValues,
        setError,
        clearErrors
      }) && isValid
    }
    dispatch({
      type: 'createCampaign/stepChange',
      payload: { step: 0, isValid: isValid, isStamp: true },
    });
  };

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_ONE_CONFIG}
        fieldsError={fieldError}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
      />
      <OnlyContinueButton
        continueAction={() => {
          stepChangeAction();
        }}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
});

export default connect(mapPropsToState)(CreateStampCampaignStepOneV2);
